import comp0 from '@/app/scriptconsent'
import comp1 from '@/app/cookieconsent'
import comp2 from '@/app/cookiebanner'
import comp3 from '@/app/sentry'
import comp4 from '@/app/scrollToAnchor'
import comp5 from '@/app/numbersreel'
import comp6 from '@/app/marquee'
import comp7 from '@/app/collapsible'
import comp8 from '@/app/galleryoverlay'
import comp9 from '@/app/joblist'
import comp10 from '@/app/googleMap'
import comp11 from '@/app/brandcarousel'
import comp12 from '@/app/slider'
import comp13 from '@/app/vouchersbalance'
import comp14 from '@/app/vouchersbuy'
import comp15 from '@/app/vouchersreload'
import comp16 from '@/app/formSelectFilter'
import comp17 from '@/app/jobsMobile'
import comp18 from '@/app/teamPie'
import comp19 from '@/app/scrollspy'
import comp20 from '@/app/toggleoverlay'
import comp21 from '@/app/autoheight'
import comp22 from '@/app/navigation'
import comp23 from '@/app/carousel'
import comp24 from '@/app/conditionalcheckbox'
var map={}; 
map['app/scriptconsent']=comp0;
map['app/cookieconsent']=comp1;
map['app/cookiebanner']=comp2;
map['app/sentry']=comp3;
map['app/scrollToAnchor']=comp4;
map['app/numbersreel']=comp5;
map['app/marquee']=comp6;
map['app/collapsible']=comp7;
map['app/galleryoverlay']=comp8;
map['app/joblist']=comp9;
map['app/googleMap']=comp10;
map['app/brandcarousel']=comp11;
map['app/slider']=comp12;
map['app/vouchersbalance']=comp13;
map['app/vouchersbuy']=comp14;
map['app/vouchersreload']=comp15;
map['app/formSelectFilter']=comp16;
map['app/jobsMobile']=comp17;
map['app/teamPie']=comp18;
map['app/scrollspy']=comp19;
map['app/toggleoverlay']=comp20;
map['app/autoheight']=comp21;
map['app/navigation']=comp22;
map['app/carousel']=comp23;
map['app/conditionalcheckbox']=comp24;
export default map;